import * as PnrActions from './pnr.actions';
import * as TabActions from './tab.actions';
import * as OperationLogActions from './operation-log.actions';
import * as TicketHistoryActions from './ticket-history.actions';
import * as ItineraryHistoryActions from './itinerary-history.actions';
import * as remarksActions from './remarks.actions';
import * as seatActions from './seat.actions';
import * as infantControlActions from './infant-control.actions';

export {
  PnrActions,
  TabActions,
  OperationLogActions,
  TicketHistoryActions,
  ItineraryHistoryActions,
  remarksActions,
  seatActions,
  infantControlActions
};
